import React from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { ICronJob } from '../../models/ICronJob';
import { useUpdateCronJobActiveMutation } from '../../store/api/cronJobsApi';
import { formatDate } from '../../utils/functions';

type CronJobsListItemProps = {
    cronJob: ICronJob;
}

const CronJobsListItem: React.FC<CronJobsListItemProps> = ({ cronJob }) => {

    const [updateCronJobActive, { isLoading }] = useUpdateCronJobActiveMutation();

    const onStatusUpdated = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await updateCronJobActive({
            alias: cronJob.alias,
            active: e.target.checked,
        });
    }

    return (
        <tr>
            <td>{cronJob.title}</td>
            <td>{cronJob.alias}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <Form.Check
                        type="switch"
                        id={`cron-job-switch-${cronJob.id}`}
                        checked={cronJob.active}
                        onChange={onStatusUpdated}
                        disabled={isLoading}
                        label={cronJob.active ? 'Active' : 'Inactive'}
                        style={{ cursor: isLoading ? 'default' : 'pointer' }}
                        className={isLoading ? '' : 'cursor-pointer'}
                    />
                    {isLoading && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className='ms-2' />}
                </div>
            </td>
            <td>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {formatDate(new Date(cronJob.created_at))}
                </div>
            </td>
        </tr>
    );
};

export default CronJobsListItem;
